export enum Tabs {
  UPCOMING = "1",
  PAST = "2",
  FAVORITE = "3",
}

export const defaultTripTypes = {
  [Tabs.UPCOMING]: new Set<string>(["Ride"]),
  [Tabs.PAST]: new Set<string>(["Ride"]),
  [Tabs.FAVORITE]: new Set<string>(["Ride"]),
};

export const defaultPageSize = {
  [Tabs.UPCOMING]: 20,
  [Tabs.PAST]: 20,
  [Tabs.FAVORITE]: 20,
};

export const defaultCurrentPage = {
  [Tabs.UPCOMING]: 1,
  [Tabs.PAST]: 1,
  [Tabs.FAVORITE]: 1,
};

export const defaultRowsToSkip = {
  [Tabs.UPCOMING]: 0,
  [Tabs.PAST]: 0,
  [Tabs.FAVORITE]: 0,
};

export const defaultSortOrder = {
  [Tabs.UPCOMING]: "ASC",
  [Tabs.PAST]: "DESC",
  [Tabs.FAVORITE]: "DESC",
};

export const defaultForceRefetch = {
  [Tabs.UPCOMING]: false,
  [Tabs.PAST]: false,
  [Tabs.FAVORITE]: false,
};
